import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return <div className="title-comparador-component">Comparador</div>;
};

export default TitleComponent;
